import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  button: {
    borderColor: theme.palette.common.white,
    color: theme.palette.common.white,
    minWidth: '9rem',
  },
}));
